import { FaApple, FaFacebook, FaGooglePlay, FaYoutube } from "react-icons/fa";
import { useSite } from "@/context/SiteContext";

export const LINKS = [
  ["app_store", "App Store link", "https://apps.apple.com/…"],
  ["google_play", "Google Play link", "https://play.google.com/store/apps/…"],
  ["facebook", "Facebook page link", "https://facebook.com/…"],
  ["youtube", "YouTube channel link", "https://youtube.com/@…"],
];

const badge = "flex h-12 items-center gap-2.5 rounded-xl px-4 shadow-sm transition-[background-color,transform] duration-300";
const ink = { backgroundColor: "#14213D", color: "#FFFFFF" };

// Shows as a link once the team adds the URL in Settings, otherwise as "Coming soon".
const Out = ({ href, testid, label, className, children }) =>
  href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} aria-label={label} style={ink} className={`${className} hover:-translate-y-0.5`}>{children}</a>
  ) : (
    <span data-testid={testid} aria-label={`${label} (coming soon)`} title="Coming soon" style={ink} className={`${className} cursor-default opacity-80`}>{children}</span>
  );

const Store = ({ href, id, Icon, small, big }) => (
  <Out href={href} testid={`footer-${id}`} label={big} className={badge}>
    <Icon className="h-6 w-6 shrink-0" />
    <span className="leading-none">
      <span className="block font-ui text-[10px] uppercase tracking-wide">{href ? small : "Coming soon to"}</span>
      <span className="mt-0.5 block font-ui text-lg font-semibold">{big}</span>
    </span>
  </Out>
);

export const AppSocial = () => {
  const { settings } = useSite();
  const l = settings?.links || {};
  return (
    <div data-testid="footer-app-social" className="mt-12 flex flex-wrap items-center gap-3">
      <Store href={l.app_store} id="app-store" Icon={FaApple} small="Download on the" big="App Store" />
      <Store href={l.google_play} id="google-play" Icon={FaGooglePlay} small="Get it on" big="Google Play" />
      <div className="flex items-center gap-2 sm:ml-4">
        <Out href={l.facebook} testid="footer-facebook" label="Facebook" className="grid h-12 w-12 place-items-center rounded-full transition-transform duration-300"><FaFacebook className="h-6 w-6" /></Out>
        <Out href={l.youtube} testid="footer-youtube" label="YouTube" className="grid h-12 w-12 place-items-center rounded-full transition-transform duration-300"><FaYoutube className="h-6 w-6" /></Out>
      </div>
    </div>
  );
};
